export default function checkLogin ({ next, router, to}) {
  if (!localStorage.getItem(`user`)) {
    setTimeout(function () {
      global.vue.$alertify.error('Bạn cần đăng nhập để thực hiện chức năng này ')
    })
    // console.log('location.pathname',location.pathname,)
    // console.log('to',to)
    window.REQUIRE_LOGIN_ROUTE_NAME = to.name
    return router.push({ name: `Login` })
	  }

  return next()
}



// WEBPACK FOOTER //
// ./src/middlewaves/checkLogin.js